import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, BadgeCheckIcon } from 'lucide-react';
import { recentBuyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const reveal = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(Math.floor(Math.random() * 12) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(reveal, FIRST_DELAY);
    const loop = window.setInterval(reveal, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-224" data-mp="1164mw3enko0r">
      {show && !dismissed && <motion.div role="status" className="fixed bottom-[92px] left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-225" data-mp="1fvsm8z39xclu">
          <div className="relative flex items-center gap-3 rounded-2xl border border-gold/40 bg-white p-3 pr-9 shadow-[0_18px_40px_-14px_rgba(11,11,12,0.5)]" data-id="element-226" data-mp="iaek4dywbnlt">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-cream object-contain" data-id="element-227" data-mp="s5eul9olpfrs" />
            <div className="min-w-0" data-id="element-228" data-mp="28iwoiwazfctx">
              <p className="text-sm font-bold leading-tight text-ink" data-id="element-229" data-mp="23ld8bquq4pzc">
                {buyer.name} <span className="font-medium text-muted" data-id="element-230" data-mp="23npp40oqwuat">from {buyer.country}</span>
              </p>
              <p className="mt-0.5 text-[13px] leading-snug text-ink" data-id="element-231" data-mp="2aqxl0m8qoee7">
                just purchased <strong data-id="element-232" data-mp="2fpr0ulbi0hhj">Sculptor’s Operating Blueprint™</strong>
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs text-muted" data-id="element-233" data-mp="2knaepk4aas8y">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-234" data-mp="2pksotdu1fdij" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-cream hover:text-ink" data-id="element-235" data-mp="1wwn2wnr8zih4">
              <XIcon className="h-4 w-4" data-id="element-236" data-mp="26p2ijef2nuyu" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}